import React from "react";

import { FlexLayout, FlexLayoutProps } from "../FlexLayout/FlexLayout";

type VStackProps = FlexLayoutProps;

/**
 * @purpose Vertical layout primitive — stacks children top-to-bottom with a
 * tokenized gap, so spacing lives on the container instead of child margins.
 *
 * @example
 * <VStack gap={16} paddingInline={24}>
 *     <SectionHeader />
 *     <SectionContent />
 * </VStack>
 */
export const VStack = (props: Readonly<VStackProps>) => (
    <FlexLayout direction="column" {...props} />
);
